import { Accompaniments } from "../modules";

export const AccompanimentsPage = () => {
  return (
    <>
      <Accompaniments />
    </>
  );
};
